import { render, staticRenderFns } from "./StatsRow.vue?vue&type=template&id=719b005a&scoped=true&"
import script from "./StatsRow.vue?vue&type=script&lang=ts&"
export * from "./StatsRow.vue?vue&type=script&lang=ts&"
import style0 from "./StatsRow.vue?vue&type=style&index=0&id=719b005a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b005a",
  null
  
)

export default component.exports